// V7: Top-right corner, minimal pill, ripple on click
import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill, spring } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";

const { fontFamily: inter } = loadInter("normal", { weights: ["600", "700", "800"], subsets: ["latin"] });

const BellSVG: React.FC<{ angle: number }> = ({ angle }) => (
  <div style={{ transform: `rotate(${angle}deg)`, transformOrigin: "top center", display: "inline-block" }}>
    <svg width="19" height="21" viewBox="0 0 64 72" fill="none">
      <circle cx="32" cy="6" r="4" fill="#B8860B" />
      <path d="M32 6C32 6 16 14 16 38V52H48V38C48 14 32 6 32 6Z" fill="#FFD700" stroke="#B8860B" strokeWidth="2" />
      <ellipse cx="32" cy="52" rx="10" ry="4" fill="#B8860B" />
      <circle cx="32" cy="58" r="5" fill="#8B6914" />
    </svg>
  </div>
);

export const DevaKathaLS7: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const slideIn = spring({ frame, fps, config: { damping: 14, stiffness: 120 }, durationInFrames: Math.round(0.7 * fps) });
  const translateX = interpolate(slideIn, [0, 1], [-200, 0]);

  const bellAngle = interpolate(frame,
    [Math.round(0.2 * fps), Math.round(0.5 * fps), Math.round(0.7 * fps), Math.round(0.9 * fps), Math.round(1.1 * fps)],
    [0, 22, -16, 8, 0],
    { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  const likeClicked = frame >= Math.round(1.5 * fps);
  const subClicked = frame >= Math.round(2.2 * fps);

  const likeRipple = interpolate(frame, [Math.round(1.5 * fps), Math.round(2.0 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });
  const subRipple = interpolate(frame, [Math.round(2.2 * fps), Math.round(2.7 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  const likeScale = interpolate(frame, [Math.round(1.5 * fps), Math.round(1.57 * fps), Math.round(1.7 * fps)], [1, 0.85, 1.06], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });
  const subScale = interpolate(frame, [Math.round(2.2 * fps), Math.round(2.27 * fps), Math.round(2.4 * fps)], [1, 0.85, 1.06], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  const slideOut = interpolate(frame, [Math.round(3.5 * fps), Math.round(4 * fps)], [0, -200], { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.4, 0, 1, 1) });

  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, transform: 'scale(1.5)', transformOrigin: 'top left' }}>
      <div style={{
        position: "absolute", top: 27, left: 33,
        transform: `translateX(${translateX + slideOut}px)`,
        display: "flex", alignItems: "center", gap: 8,
        background: "rgba(8,6,2,0.9)", backdropFilter: "blur(10px)",
        borderRadius: 33, padding: "7px 13px 7px 9px",
        border: "1px solid rgba(255,215,0,0.35)",
        boxShadow: "0 4px 24px rgba(0,0,0,0.6)",
      }}>
        <BellSVG angle={bellAngle} />
        <span style={{ color: "#FFD700", fontSize: 9, fontWeight: 700, fontFamily: inter, letterSpacing: 0.5 }}>Deva Katha</span>
        <div style={{ width: 1, height: 16, background: "rgba(255,255,255,0.15)" }} />

        <div style={{ position: "relative" }}>
          {likeClicked && <div style={{
            position: "absolute", inset: -4,
            borderRadius: 16, border: "2px solid #1a73e8",
            opacity: 1 - likeRipple, transform: `scale(${1 + likeRipple * 0.5})`,
          }} />}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            background: likeClicked ? "#1a73e8" : "rgba(255,255,255,0.1)",
            borderRadius: 16, padding: "5px 11px", transform: `scale(${likeScale})`,
            border: `1px solid ${likeClicked ? "transparent" : "rgba(255,255,255,0.2)"}`,
          }}>
            <span style={{ color: "#fff", fontSize: 9, fontWeight: 700, fontFamily: inter, whiteSpace: "nowrap" }}>{likeClicked ? "👍 Liked!" : "👍 Like"}</span>
          </div>
        </div>

        <div style={{ position: "relative" }}>
          {subClicked && <div style={{
            position: "absolute", inset: -4,
            borderRadius: 16, border: "2px solid #FF0000",
            opacity: 1 - subRipple, transform: `scale(${1 + subRipple * 0.5})`,
          }} />}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            background: subClicked ? "#606060" : "#FF0000",
            borderRadius: 16, padding: "5px 11px", transform: `scale(${subScale})`,
            boxShadow: subClicked ? "none" : "0 2px 12px rgba(255,0,0,0.5)",
          }}>
            <span style={{ color: "#fff", fontSize: 9, fontWeight: 800, fontFamily: inter, whiteSpace: "nowrap" }}>{subClicked ? "Subscribed ✓" : "Subscribe"}</span>
          </div>
        </div>
      </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
